var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.7595C5.5 11.4018 5.5 10.7229 5.77446 10.1262C6.04892 9.52943 6.56437 9.08763 7.59525 8.20401L8.59525 7.34687C10.4586 5.74974 11.3902 4.95117 12.5 4.95117C13.6098 4.95117 14.5414 5.74974 16.4047 7.34687L17.4047 8.20401C18.4356 9.08763 18.9511 9.52943 19.2255 10.1262C19.5 10.7229 19.5 11.4018 19.5 12.7595V16.9999C19.5 18.8856 19.5 19.8284 18.9142 20.4142C18.3284 20.9999 17.3856 20.9999 15.5 20.9999H9.5C7.61438 20.9999 6.67157 20.9999 6.08579 20.4142C5.5 19.8284 5.5 18.8856 5.5 16.9999V12.7595Z",
    stroke: "#707070",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21V16C15 15.4477 14.5523 15 14 15H11C10.4477 15 10 15.4477 10 16V21",
    stroke: "#707070",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.bd52cfcb3c370d5315ed638a89190c69.svg";
export { ForwardRef as ReactComponent };